"use client";

import { useRouter } from 'next/navigation';
import React from 'react';
import { usePagination } from "@/app/context/StateProvider";
import ReactGA from "react-ga4";
import styles from "./LoadMore.module.css";
export default function LoadMore() {
  const router = useRouter();
  const [pagination, setPagination] = usePagination();
  ReactGA.event({
    category: "Button Click",
    action: "Load More"
  });

  //This function will be executed when the user clicks the "Load More" button
  const loadMore = () => {
    const newPagination: number = pagination + 1;

    //console.log("load more, newPagination: ", newPagination);
    setPagination(newPagination);
  };
  return <button onClick={() => loadMore()} className={styles.loadMoreButton} data-sentry-component="LoadMore" data-sentry-source-file="LoadMore.tsx">Load more</button>;
}